import React from 'react';
import {  Outlet } from 'react-router-dom';
import '../../assets/user/css/style.css';
import '../../assets/user/css/responsive.css';
import './style.scss';

import NavbarHome from './Navbar';
import Footer from './Footer';


const MasterLayout = () => {
    const sidenavToggle = () => {
        const navbarSupportedContent = document.getElementById('navbarSupportedContent');

        let testClass = navbarSupportedContent.className;

        if (testClass === 'navbar-collapse collapse show' && window.innerWidth < 992) {
            navbarSupportedContent.classList.remove('show');
        }
    }

    return (
        <div className='sb-nav-fixed' id="sb-nav-fixed">
            <NavbarHome  />

            <div id="layoutSidenav">
                <div id="layoutSidenav_content" >
                    <main>
                        <Outlet />
                    </main>
                    <Footer />
                </div>
            </div >
        </div >
    );
}

export default MasterLayout;
